import React from 'react';
import './RelationshipBadge.css';

/**
 * Badge component for displaying task relationship types with appropriate colors.
 * Primary types: Depends on, Blocked by, Duplicate. Reverse types for display (required_by, blocks, duplicated_by).
 * Legacy: relates_to for existing data.
 * @param {string} relationshipType - The relationship type (depends_on, blocked_by, duplicates, etc.)
 * @param {string} direction - The direction from the current task's perspective
 * @param {string} className - Additional CSS classes
 */
const RelationshipBadge = ({ relationshipType, direction, className = '' }) => {
  const getBadgeConfig = (relType) => {
    const configs = {
      'depends_on': { label: 'Depends on', color: '#7c3aed', bgColor: '#ede9fe' },
      'required_by': { label: 'Required by', color: '#9333ea', bgColor: '#f3e8ff' },
      'blocked_by': { label: 'Blocked by', color: '#ea580c', bgColor: '#ffedd5' },
      'blocks': { label: 'Blocks', color: '#dc2626', bgColor: '#fee2e2' },
      'duplicates': { label: 'Duplicate', color: '#ca8a04', bgColor: '#fef9c3' },
      'duplicated_by': { label: 'Duplicated by', color: '#ca8a04', bgColor: '#fef9c3' },
      'relates_to': { label: 'Relates to', color: '#6b7280', bgColor: '#f3f4f6' },
      'subtask': { label: 'Subtask', color: '#64748b', bgColor: '#f1f5f9' },
      'parent_of': { label: 'Part of', color: '#475569', bgColor: '#e2e8f0' }
    };
    return configs[relType] || { label: relType || 'Link', color: '#6b7280', bgColor: '#f3f4f6' };
  };

  const config = getBadgeConfig(direction || relationshipType);

  return (
    <span
      className={`relationship-badge ${className}`}
      style={{
        color: config.color,
        backgroundColor: config.bgColor,
        borderColor: config.color
      }}
    >
      {config.label}
    </span>
  );
};

export default RelationshipBadge;

